import { TopToolbar, useRedirect } from "react-admin";
import { Breadcrumb, BreadcrumbItem } from "@react-admin/ra-navigation";
import { useLocation, Location } from "react-router-dom";
import BulkShareClassExtraction from "frontend/src/components/BulkShareClassExtraction";
import { Box } from "@mui/material";

const getInvestmentFromSearchParams = (
  location: Location
): { id: number; name: string; marketEnumId: number } | null => {
  try {
    const searchParams = new URLSearchParams(location.search);
    const sourceParam = searchParams.get("source");
    if (!sourceParam) return null;
    return JSON.parse(sourceParam)?.investment || null;
  } catch (error) {
    return null;
  }
};

const BreadcrumbActions = () => {
  const location = useLocation();
  const investment = getInvestmentFromSearchParams(location);

  if (!investment?.id) return null;

  return (
    <TopToolbar sx={{ justifyContent: "flex-start" }}>
      <Breadcrumb>
        <BreadcrumbItem
          name="investment"
          label={decodeURIComponent(investment.name)}
          to={`/investment/${investment.id}`}
        />
        <BreadcrumbItem
          name="investmentTerms"
          label="Terms"
          to={`/investmentTerms/${investment.id}`}
        />
      </Breadcrumb>
    </TopToolbar>
  );
};

export function ShareClassBulkExtract() {
  const location = useLocation();
  const redirect = useRedirect();
  const investment = getInvestmentFromSearchParams(location);

  if (!investment?.id) {
    return (
      <Box sx={{ p: 3 }}>
        <BreadcrumbActions />
        <div>
          Invalid investment information. Please navigate from the investment
          terms page.
        </div>
      </Box>
    );
  }

  const handleSuccess = () => {
    // Navigate back to investment terms page
    redirect(`/investmentTerms/${investment.id}`);
  };

  return (
    <Box sx={{ p: 3 }}>
      <BreadcrumbActions />
      <BulkShareClassExtraction
        investmentId={investment.id}
        investmentName={decodeURIComponent(investment.name)}
        marketEnumId={investment.marketEnumId}
        onSuccess={handleSuccess}
      />
    </Box>
  );
}
